module.exports = __webpack_public_path__ + "img/logo.622c23e2.svg";